const STORAGE_KEY_PREFIX = "xplatform-mapping:edits:";

/**
 * Remove the edits older builds mirrored to localStorage for this job.
 *
 * Edits are in memory now (see `useJobResults`). A browser that ran the old
 * build can still hold a stored edit whose save failed, and it would never be
 * read again, so drop it the first time the job is opened.
 */
export const clearLegacyEditsStorage = (jobId: string): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(`${STORAGE_KEY_PREFIX}${jobId}`);
  } catch {
    /* storage unavailable: nothing was stored either */
  }
};
